import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { ActionService } from "../services/action.service";
import { Globals } from "../services/globals";

@Injectable({
  providedIn: "root",
})
export class LibrarySelectedGuard {
  public constructor(
    protected router: Router,
    protected service: ActionService
  ) {}

  public canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const ret = Globals.LastSelectedLibraryId;
    if (ret) {
      return true;
    } else {
      this.router.navigate(["/login"], { replaceUrl: true });
      return false;
    }
  }
}
